import React from "react";
import IcomoonReact from "icomoon-react";
import iconSet from "../../assets/selection.json";
const Icon: React.FC<{
  color?: string;
  size?: string | number;
  icon: string;
  className?: string;
  style?: React.CSSProperties;
}> = (props) => {
  const { color, size = 25, icon, className = "", style } = props;
  return (
    <IcomoonReact
      className={className}
      iconSet={iconSet}
      color={color}
      size={size}
      icon={icon}
      style={style}
    />
  );
};
export default Icon;